import { observer } from 'mobx-react-lite'
import { Platform, ScrollView, StyleSheet, Text, View } from 'react-native'

import { translate } from '../../../../../i18n'
import { useStore } from '../../../../../models'
import { color, fontFamily } from '../../../../../theme'
import { SidePot } from './SidePot'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export interface SidePotsProps extends Record<string, never> {}

export const SidePots = observer(() => {
  const {
    game: { sidePots }
  } = useStore()

  const sortedPots = sidePots.sort((a, b) => b.amount - a.amount)

  return (
    <BottomSheetView style={Platform.OS !== 'web' ? { flex: 1 } : {}}>
      <View style={styles.bottomSheetContainer}>
        <Text style={styles.title}>SIDE POTS</Text>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.container}>
          {sortedPots.map((pot, i) => (
            <SidePot key={`pot-${i}`} pot={pot} />
          ))}
          <Text style={styles.text}>{translate('newGameScreen.common.sidePots')}</Text>
        </ScrollView>
      </View>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  bottomSheetContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: color.backgroundColor,
    paddingHorizontal: 20
  },
  container: {
    gap: 10,
    paddingBottom: 80
  },
  title: {
    fontFamily: fontFamily.GTAmericaExtended,
    fontWeight: 'bold',
    fontSize: 12,
    color: '#121212',
    marginBottom: 20
  },
  text: {
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontWeight: '400',
    fontSize: 14,
    color: color.smokyBlack
  },
  potContainer: {
    borderColor: 'lightgray',
    borderWidth: 1,
    width: '90%'
  }
})
